/**
 * Machina Callida Backend REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Linguistic phenomena: syntactic dependencies, morphological features, lemmata, parts of speech.
 */
export type Phenomenon = 'dependency' | 'feats' | 'lemma' | 'upos';

export const Phenomenon = {
    Dependency: 'dependency' as Phenomenon,
    Feats: 'feats' as Phenomenon,
    Lemma: 'lemma' as Phenomenon,
    Upos: 'upos' as Phenomenon
};

